// extracted by mini-css-extract-plugin
export var columnList = "_gf-0";